import ColorBoxes from './ColorBoxes';
import './styles/App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <ColorBoxes/>
      </header>
    </div>
  );
}

export default App;
